import React from 'react';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';

const ProteinVariantIngredientCard = (props) => {
  const { ingredient } = props;

  return (
    <div id='proteinvariantingredientcard-wrapper' className="w-[94%] h-[26%] flex flex-row mb-[1%] mt-[1%] ml-[2%] border border-[#CACACA] border-solid rounded-[4px]">
      <div id='proteinvariantingredientcard-container' className="w-[16%] h-[100%] flex flex-row items-center justify-center">
        <RMSvgIcon
          id='proteinvariantingredientcard-svg-formulation-icon'
          name="ProteinFormulation"
          fill="#414042"
          height="2.25rem"
          width="2.25rem"
        />
      </div>
      <div id={`proteinvariantingredientcard-content-${ingredient.id}`} className="w-[84%] flex flex-col h-[100%] justify-center">
        <div id={`proteinvariantingredientcard-title-${ingredient.name}`} className="text-[#313131] text-[0.923rem] font-bold">
          {ingredient.name || 'Protein'}
        </div>
        <div id={`proteinvariantingredientcard-subtitle-${ingredient.concentrationmgmL}`} className="text-[#5D5D5D] text-[0.923rem] ">
          Conc: {ingredient.concentrationmgmL || '0'} mg/mL,{' '}
          {ingredient.concentrationmM || '0'} mM, {ingredient.molecularWeight || '0'} kDa
        </div>
      </div>
    </div>
  );
};

export default ProteinVariantIngredientCard;
